
import { LoginOut} from "@/api/api.js";

export default {
  
//   install(Vue) {
//     const INACTIVITY_TIMEOUT =60 * 1000 // 5分钟
//     const WARNING_TIMEOUT = 0.5 * 60 * 1000 // 提前30秒警告
//     let logoutTimer
//     let warningTimer
//     let warningShown = false

//     const resetTimers = () => {
//       clearTimeout(logoutTimer)
//       clearTimeout(warningTimer)
//       warningShown = false
      
//       logoutTimer = setTimeout(() => {
//         // Vue.prototype.$logout()
       
//         console.log(`logut`, 'logut');
//       //  SubmitLoginOut()
//       }, INACTIVITY_TIMEOUT)

//       warningTimer = setTimeout(() => {
//         if (!warningShown) {
//           console.log('您将在30秒后因长时间无操作被自动登出');
          
//           Vue.prototype.$notify.warning('您将在30秒后因长时间无操作被自动登出')
//           warningShown = true
//         }
//       }, WARNING_TIMEOUT)
//     }

//     const activityEvents = [
//       'mousemove', 'keydown', 'click', 'scroll',
//       'touchstart', 'touchmove', 'touchend'
//     ]
// console.log('当前监听事件:', activityEvents);
//     Vue.prototype.$startInactivityTimer = () => {
//       resetTimers()
//       activityEvents.forEach(event => {
//         window.addEventListener(event, resetTimers)
//       })

// // activityEvents.forEach(event => {
// //     window.addEventListener(event, () => {
// //         console.log(`事件触发: ${event}`, new Date().toLocaleTimeString());
// //     });
// // });
//       // 跨标签页同步
//       window.addEventListener('storage', (e) => {
//         console.log(e);
        
//         if (e.key == 'lastActivityTime') {
//           resetTimers()
//         }
//       })
//     }

//     Vue.prototype.$stopInactivityTimer = () => {
//       clearTimeout(logoutTimer)
//       clearTimeout(warningTimer)
//       console.log(111);
      
//       activityEvents.forEach(event => {
//         window.removeEventListener(event, resetTimers)
//       })
//     }
//   },

    install(Vue){
      const INACTIVITY_TIMEOUT =  60 * 60 * 1000; // 5分钟
const WARNING_TIMEOUT = 59 * 60 * 1000; // 提前30秒警告

let logoutTimer;
let warningTimer;
let warningShown = false;

// 更新最后活动时间
const updateLastActivityTime = () => {
  const currentTime = new Date().toISOString();
  localStorage.setItem('lastActivityTime', currentTime);
};

// 重置计时器
const resetTimers = () => {
  clearTimeout(logoutTimer);
  clearTimeout(warningTimer);
  warningShown = false;

  logoutTimer = setTimeout(() => {
    console.log('logging out...');
         clearTimeout(logoutTimer);
  clearTimeout(warningTimer);
      LoginOut({}).then((res) => {
        
        if (res.code == 200) {
Vue.prototype.$notify.success(res.msg);
        }
        sessionStorage.clear();
        localStorage.removeItem("token");
        localStorage.removeItem("renzheng");
        localStorage.removeItem("userInfo");
        localStorage.removeItem("userInfoImg");
        window.location.href = "/";
      });
 

    // SubmitLoginOut();  // 调用登出函数
  }, INACTIVITY_TIMEOUT);

  warningTimer = setTimeout(() => {
    if (!warningShown) {
      Vue.prototype.$notify.warning('You will be automatically logged out after 1 minute due to prolonged inactivity');
      warningShown = true;
    }
  }, WARNING_TIMEOUT);
};

// 启动计时器
Vue.prototype.$startInactivityTimer = function() {
  const lastActivityTime = localStorage.getItem('lastActivityTime');
  if (lastActivityTime) {
    const lastActivity = new Date(lastActivityTime);
    const currentTime = new Date();
    if (currentTime - lastActivity > INACTIVITY_TIMEOUT) {
      // SubmitLoginOut();  // 如果超时，自动登出
    }
  }

  resetTimers();
     const activityEvents = [
      'mousemove', 'keydown', 'click', 'scroll',
      'touchstart', 'touchmove', 'touchend'
    ]
  // 监听用户活动
  activityEvents.forEach(event => {
    window.addEventListener(event, () => {
      updateLastActivityTime();  // 更新活动时间
      resetTimers();  // 重置计时器
    });
  });

  // 监听跨标签页同步
  window.addEventListener('storage', (e) => {
    if (e.key === 'lastActivityTime') {
      const lastActivityTime = new Date(e.newValue);
      const currentTime = new Date();
      if (currentTime - lastActivityTime < INACTIVITY_TIMEOUT) {
        resetTimers();
      }
    }
  });
};

// 停止计时器
Vue.prototype.$stopInactivityTimer = function() {
  clearTimeout(logoutTimer);
  clearTimeout(warningTimer);
  activityEvents.forEach(event => {
    window.removeEventListener(event, () => {
      updateLastActivityTime();
      resetTimers();
    });
  });
};

    }
    
}
